class CountrySelect {

    constructor() {
        this.url = '/ajax/countries/all/';
        this.country = '';
        this.address_id = '';

        this._debug = {
            url: true,
            set_all: true,
            get_all: true,
        }
    }
    
    _methods = { // ----------------------- Start Methods -----------------
        _setters: { // ----------------------- Start - Setters -------------------
            _properties: {
                set_url: (url) => this.url = url,
                set_country: (country) => this.country = country,
                set_address_id: (id) => this.address_id = id,
            
                set_all_existing_values: (data) => {
                    const setters = this._methods._setters._properties;
                    this.data.url ? setters.set_url(data.url) : '';
                    this.data.country ? setters.set_country(data.country) : '';
                    this.data.address_id ? setters.set_address_id(data.address_id) : '';
                }
            },
            _ui: {
                set_country: (country) => this.country = country,
                set_address_id: (id) => this.address_id = id,
            
                set_all_existing_values: (data) => {
                    const setters = this._methods._setters._ui;
                    setters.set_country(data.country);
                    setters.set_address_id(data.address_id);
                }
            }
        }, // ----------------------- End - Setters -------------------   
        _getters: { // ----------------------- Start - Getters -------------------
            get_url: (url) => this.url,
            get_country: (country) => this.country,
            get_address_id: (id) => this.address_id,
        
            get_all_existing_values: () => {
                const getters = this._methods._getters;
                this.data.url ? getters.get_url(data.url) : '';
                this.data.country ? getters.get_country(data.country) : '';
                this.data.address_id ? getters.get_address_id(data.address_id) : '';
            }
        }, // ----------------------- End - Getters -------------------
        _builders: { // ----------------------- Start - Builders -------------------
            build_country_select: (address_id) => {
                return am.$(this._methods._builders.build_country_select_html(address_id));
            },
            build_country_select_html: (address_id) => {
                return `
                    <div class="am-section-row address-country">
                        <label class="am-section-label" id="country-label" for="country-${address_id}">${get_language_translation('LANG_LABEL_COUNTRY')}</label> 
                        <div class="am-section-parent">
                            <select id="country-${address_id}" name="address[country][${address_id}]" class="am-select-dropdown js-required js-address-country places_country_${address_id}" onchange="new StateSelect()._methods._helpers.state_get_ajax(this);">
                                <option value="" selected >${get_language_translation('LANG_OPT_SELECT')}</option>
                            </select>
                        </div>
                    </div>
                `;
            }
        }, // ----------------------- End - Builders -------------------
        _helpers: { // ----------------------- Start - Helpers -------------------
            country_get_ajax: (address_id) => {
                const country = this;
                try{
                    country._methods._helpers.add_loading_country(address_id);
                    am.$.getJSON('/ajax/countries/all/', function (data) {  
                        data.each((opt, i) => {
                            const $opt = `<option id="${opt.country_id}" value="${opt.name}">${opt.name}</option>`;
                            am.$(`#country-${address_id}`).append($opt);
                        })
                    })
                    .done(function() {
                        country._methods._helpers.remove_country_loading(address_id);
                    })
                    .fail(function(e) {
                        console.log(e);
                    })
                }
                catch(e){
                }
            },
            add_loading_country: (address_id) => {
                am.$(`#country-${address_id}`).append(`<option id="loading-option[${address_id}]" value="" >"Loading..."</option>`);
            },
            remove_country_loading: (address_id) => {
                am.$(`#loading-option[${address_id}]`).remove();
            },
        }, // ----------------------- End - Helpers -------------------
    } // ----------------------- End Std Methods -----------------

}